import { render, staticRenderFns } from "./LavaderoMetricasHistoricas.vue?vue&type=template&id=8ba8f076&scoped=true"
import script from "./LavaderoMetricasHistoricas.vue?vue&type=script&lang=js"
export * from "./LavaderoMetricasHistoricas.vue?vue&type=script&lang=js"
import style0 from "./LavaderoMetricasHistoricas.vue?vue&type=style&index=0&id=8ba8f076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba8f076",
  null
  
)

export default component.exports